import React from 'react';
import styled from 'styled-components';
import { RectShape } from 'react-placeholder/lib/placeholders';
import "react-placeholder/lib/reactPlaceholder.css";
import { device } from 'vqp-common';

import useFetch from '../../utils/useFetch'
import { fetchUserRecurrence, fetchPaymentMethods, fetchOrderKind, fetchSaleChannels } from '../../redux/actions/dashboard'
import { PieChart } from '.'

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    margin: 15px;

    @media ${device.desktop} {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
`


export const PieChartsPanel = ({filterDates}) => {

    const userRecurrence = useFetch(fetchUserRecurrence, filterDates)
    const paymentMethods = useFetch(fetchPaymentMethods, filterDates)
    const ordersType = useFetch(fetchOrderKind, filterDates)
    const saleChannels = useFetch(fetchSaleChannels, filterDates)

    const drawChart = (title, data, type) => {
        if (data.loading) 
            return (
                <RectShape color='#E0E0E0' showLoadingAnimation={true} style={{ width: '100%', height: 300 }} />
            )
        else if (data.response) {
            return (
                <PieChart title={title} data={data.response.dataset} labels={data.response.labels} type={type} />
            )
        }
        return null
    }
    
    return (
        <Grid>
            {drawChart("Usuários", userRecurrence, "donut")}
            {drawChart("Formas de pagamento", paymentMethods, "pie")}
            {drawChart("Modalidade de pagamento", ordersType, "pie")}
            {drawChart("Canais de venda", saleChannels, "pie")}
        </Grid>
    )
}